import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as endpoint from "./../../../Service/endpoints";
import Modal from "../../UI/Modal";
import Icon from "../../UI/Icon";
import { Logo } from "../../UI/Primitives";
import ThemeToggle from "../../Layout/ThemeToggle";
import { NAV_CATEGORIES, getCategoryMeta } from "../../User/Catalog/categoryMeta";

// Mobile navigation drawer (driven by the existing user.menu.* actions).
function MainSidebar() {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.userMenu.show);
  const userState = useSelector((state) => state.userState);
  const city = endpoint.getCurrentCity();
  const cityLabel = city.charAt(0).toUpperCase() + city.slice(1);

  const close = () => dispatch({ type: "user.menu.hide" });

  const signIn = () => {
    close();
    dispatch({ type: "login.window.show" });
  };

  const changeCity = () => {
    close();
    dispatch({ type: "user.city.show" });
  };

  const logout = () => {
    delete localStorage.keycloak;
    window.location.href = "./";
  };

  const categories = [...NAV_CATEGORIES];
  if (city === "gurgaon") categories.push("expressDelivery");

  return (
    <Modal open={open} onClose={close} title="Menu" hideTitle variant="drawer">
      <div className="v-drawer">
        <div className="v-drawer__top">
          <Logo height={22} />
          <button type="button" className="v-icon-btn" onClick={close} aria-label="Close menu">
            <Icon name="close" />
          </button>
        </div>

        <button type="button" className="v-drawer__city" onClick={changeCity}>
          <Icon name="pin" size={18} />
          <span>
            <span className="v-drawer__city-label">Delivering in</span>
            <strong>{cityLabel}</strong>
          </span>
          <span className="v-drawer__city-change">Change</span>
        </button>

        <nav aria-label="Mobile">
          <ul className="v-drawer__list">
            <li>
              <Link to={endpoint.getPath("")} onClick={close} className="v-drawer__link">
                <Icon name="home" size={20} /> Home
              </Link>
            </li>
            {categories.map((slug) => (
              <li key={slug}>
                <Link to={endpoint.getPath(slug)} onClick={close} className="v-drawer__link">
                  <Icon name={slug === "expressDelivery" ? "bolt" : "layers"} size={20} />
                  {getCategoryMeta(slug).short}
                  <Icon name="chevronRight" size={16} className="v-drawer__chev" />
                </Link>
              </li>
            ))}
            <li>
              <Link to="/customization" onClick={close} className="v-drawer__link">
                <Icon name="wrench" size={20} /> Customization
              </Link>
            </li>
            <li>
              <a href="https://p2p.voorent.com/" className="v-drawer__link">
                <Icon name="tag" size={20} /> List Item
                <Icon name="arrowUpRight" size={16} className="v-drawer__chev" />
              </a>
            </li>
          </ul>
        </nav>

        <div className="v-drawer__section">
          <span className="v-drawer__label">Appearance</span>
          <ThemeToggle variant="segmented" />
        </div>

        <div className="v-drawer__footer">
          {userState.loggedIn ? (
            <>
              <a href={endpoint.getRoot("account")} className="v-btn v-btn--secondary v-btn--block">
                <Icon name="user" size={18} /> My account
              </a>
              <button type="button" className="v-btn v-btn--ghost v-btn--block" onClick={logout}>
                Log out
              </button>
            </>
          ) : (
            <button type="button" className="v-btn v-btn--primary v-btn--block" onClick={signIn}>
              Login / Sign up
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default MainSidebar;
